import {ChangeDetectionStrategy, Component, Input, OnInit,} from '@angular/core';
import { NgClass, SlicePipe, TitleCasePipe } from '@angular/common';
import {ContainerModel} from '@app/models/server/layout.model';
import {SafePipe} from '@app/components/pipes/safe/safe.pipe';
import {B2bDeviceUtilService} from '@app/services/util-services/root-services/b2b-device-util.service';
import {ToParagraphPipe} from '@app/components/pipes/to-paragraph/to-paragraph.pipe';

@Component({
  selector: 'app-b2b-information-card',
  templateUrl: './b2b-information-card.component.html',
  styleUrls: ['./b2b-information-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgClass, TitleCasePipe, SafePipe, SlicePipe, ToParagraphPipe],
})
export class B2bInformationCardComponent implements OnInit {
  @Input() compData: {
    container: ContainerModel;
    hideBorder?: boolean;
  };

  readMore: boolean;
  isDesktop: boolean;

  // @Output() selectEvent: EventEmitter<any> = new EventEmitter<any>();

  constructor(private b2bDeviceUtilService: B2bDeviceUtilService) {
    this.isDesktop = this.b2bDeviceUtilService.isDesktop();
    this.readMore = this.isDesktop;
  }

  ngOnInit() {
    // console.warn('compData is ', this.compData);
  }

  onClick(): void {
    // this.selectEvent.emit(this.compData);
  }
}
